export const SPONSOR_LOGOS: { [key: string]: string } = {
  // Only sponsors with a resolvable (remote) logo are listed. pindos / meatFarm
  // use local assets bundled on the kiosk app but NOT in mobileorder, so they
  // are intentionally omitted: a store that whitelists them shows no banner
  // (resolveSponsorLogoByKey returns null) rather than a transient broken image.
  // Add their asset URLs here if those sponsors should ever render on mobileorder.
  cocacola:
    "https://data.deliverymanager.gr/sponsorImages/cocaCola_sponsor_1.png",
  pepsi: "https://data.deliverymanager.gr/sponsorImages/pepsi_sponsor_1.png",
  hellmanns:
    "https://data.deliverymanager.gr/sponsorImages/hellmanns_sponsor_1.png",
};

/** Resolve a sponsor key (e.g. from a cart product) to its logo URL, or null. */
export function resolveSponsorLogoByKey(sponsorLogo: string): string | null {
  return Object.prototype.hasOwnProperty.call(SPONSOR_LOGOS, sponsorLogo)
    ? SPONSOR_LOGOS[sponsorLogo]
    : null;
}
